const episodeSlugKeys = {
    all: () => [{ entity: 'episodeSlug' }],
    detailByEpisodeId: (rawEpisodeId, name) => [
        { ...episodeSlugKeys.all()[0], episodeId: Number(rawEpisodeId), name },
    ],
};

export default episodeSlugKeys;
